import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { SetSelectedLandLine } from '../../store/actions/selected-landline.actions';

@Component({
  selector: 'app-modal-land-lines-list',
  templateUrl: './modal-land-lines-list.component.html',
  styleUrls: ['./modal-land-lines-list.component.css'],
  standalone: false
})
export class ModalLandLinesListComponent implements OnInit {

  @Input()
  landLineList: Array<LandLineListInterface>;

  landLineListCopy: Array<LandLineListInterface>;

  @Input()
  visibility = true;

  @Output()
  closedListLines = new EventEmitter<number>();

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.landLineListCopy = this.landLineList;
  }

  closeLinesList(e) {
    this.visibility = false;
    this.closedListLines.emit(1);
  }

  filter($event) {
    if ($event.target.value === '') {
      this.landLineListCopy = this.landLineList;
    } else {
      this.landLineListCopy = [];
      for (const landline of this.landLineList) {
        if (landline.phoneNumber.includes($event.target.value) || landline.titular.toLowerCase().includes($event.target.value.toLowerCase())
        ) {
          this.landLineListCopy.push(landline);
        }
      }
    }
  }

  setSelectedLine(phoneNumber?: string) {
    this.landLineListCopy = this.landLineList;
    this.store.dispatch(new SetSelectedLandLine(this.landLineListCopy.find((line) => line.phoneNumber === phoneNumber)));
    this.visibility = false;
  }
}
